/**
 * Leave the live room shell.
 * Soft React Router navigate can change the URL while LiveKit disconnect
 * state keeps LiveSessionRoom mounted, so Leave never shows the session list.
 */

export function sessionListExitUrl(
  homePath: string,
  loc: {
    pathname: string;
    search: string;
    hash: string;
    isElectron?: boolean;
  },
): string {
  const hashMode = Boolean(loc.isElectron) || loc.hash.startsWith("#/");
  if (hashMode) {
    return `${loc.pathname}${loc.search}#${homePath}`;
  }
  return homePath;
}

export function exitToSessionList(homePath: string): void {
  if (typeof window === "undefined") return;
  const isElectron = Boolean(
    (window as Window & { electronAPI?: { isElectron?: boolean } }).electronAPI
      ?.isElectron,
  );
  window.location.replace(
    sessionListExitUrl(homePath, {
      pathname: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash,
      isElectron,
    }),
  );
}
